<div class="add-container">
    <div class="d-flex justify-content-between align-items-center">
        <h1 class="add-title m-0 p-0">Ieșire/Expediere</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <br>
    <!-- Step 1: Chose Entity type -->
    <ng-container *ngIf="step === 1">
        <div class="text-center d-flex flex-column gap-2">
            <button type="button" style="background-color:#00c0ef; border-color: #00acd6; color: #fff"
                class="btn-general" (click)="chooseEntityType(0)">
                <i class="fa-solid fa-plus add-icon"></i>
                <span>Adaugă AWB Petent</span>
            </button>
            <button *ngIf="docData.entity_emitent_extern" type="button"
                style="background-color:#3c8dbc; border-color: #367fa9; color: #fff" class="btn-general"
                (click)="chooseEntityType(1)">
                <i class="fa-solid fa-plus add-icon"></i>
                <span>Adaugă AWB Extern</span>
            </button>
            <button type="button" style="background-color: #00a65a;  border-color: #008d4c; color: #fff;"
                class="btn-general" (click)="chooseEntityType(2)">
                <i class="fa-solid fa-plus add-icon"></i>
                <span>Adaugă AWB Alte Destinații</span>
            </button>
        </div>
    </ng-container>
    <!-- Step 2: Fill form -->
    <ng-container *ngIf="step === 2">
        <form [formGroup]="formExtern">
            <h3 class="m-0">Adresa</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Denumire Emitent</mat-label>
                        <input type="text" matInput [formControl]="entitatiExternControl"
                            [matAutocomplete]="autoEntitateExtern" (change)="onEntitateExternChange()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                        <mat-autocomplete #autoEntitateExtern="matAutocomplete" [displayWith]="displayEntitateExtern"
                            (optionSelected)="onEntitateExternSelected($event.option.value)">
                            <mat-option *ngIf="showEntitatiExternMessage" disabled>
                                <span *ngIf="!entitatiExternControl.value || entitatiExternControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isEntitatiExternLoading && entitatiExternControl.value && entitatiExternControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isEntitatiExternLoading && entitatiExternLoadComplete && entitatiExtern.length === 0 && entitatiExternControl.value && entitatiExternControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let entitate of entitatiExtern" [value]="entitate">
                                {{ entitate.denumire }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="!entitatiExternControl.valid && entitatiExternControl.touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="email" />
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Telefon</mat-label>
                        <input type="text" matInput formControlName="telefon" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Țară</mat-label>
                        <input matInput [formControl]="tariExternControl" [matAutocomplete]="autoTariExtern"
                            (blur)="onTariExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoTariExtern="matAutocomplete" [displayWith]="displayTariExtern"
                            (optionSelected)="onTariExternChange($event.option.value)">
                            <mat-option *ngIf="filteredTariExtern.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let tara of filteredTariExtern" [value]="tara">
                                {{ tara.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="!tariExternControl.valid && tariExternControl.touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Județ</mat-label>
                        <input matInput [formControl]="judeteExternControl" [matAutocomplete]="autoJudeteExtern"
                            (blur)="onJudeteExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoJudeteExtern="matAutocomplete" [displayWith]="displayJudeteExtern"
                            (optionSelected)="onJudeteExternChange($event.option.value)">
                            <mat-option *ngIf="filteredJudeteExtern.length === 0" disabled>
                                Nu au fost găsite rezultate
                            </mat-option>
                            <mat-option *ngFor="let judet of filteredJudeteExtern" [value]="judet">
                                {{ judet.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="!judeteExternControl.valid && judeteExternControl.touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Localitate</mat-label>
                        <input matInput [formControl]="localitatiExternControl" [matAutocomplete]="autoLocalitatiExtern"
                            (blur)="onLocalitatiExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoLocalitatiExtern="matAutocomplete"
                            [displayWith]="displayLocalitatiExtern"
                            (optionSelected)="onLocalitatiExternSelected($event.option.value)">
                            <mat-option *ngIf="showLocalitatiExternMessage" disabled>
                                <span
                                    *ngIf="!localitatiExternControl.value || localitatiExternControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isLocalitatiExternLoading && localitatiExternControl.value && localitatiExternControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isLocalitatiExternLoading && localitatiExternLoadComplete && localitatiExtern.length === 0 && localitatiExternControl.value && localitatiExternControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let localitate of localitatiExtern" [value]="localitate">
                                {{ localitate.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="!localitatiExternControl.valid && localitatiExternControl.touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Sector</mat-label>
                        <mat-select formControlName="sector">
                            <mat-option value="-1">--Alegeți--</mat-option>
                            <mat-option value="1">Sector 1</mat-option>
                            <mat-option value="2">Sector 2</mat-option>
                            <mat-option value="3">Sector 3</mat-option>
                            <mat-option value="4">Sector 4</mat-option>
                            <mat-option value="5">Sector 5</mat-option>
                            <mat-option value="6">Sector 6</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-4 d-flex flex-row gap-1">
                    <mat-form-field appearance="fill">
                        <mat-label>Stradă</mat-label>
                        <input matInput [formControl]="straziExternControl" [matAutocomplete]="autoStraziExtern"
                            (blur)="onStraziExternBlur()" />
                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                        <mat-autocomplete #autoStraziExtern="matAutocomplete" [displayWith]="displayStraziExtern"
                            (optionSelected)="onStraziExternSelected($event.option.value)">
                            <mat-option *ngIf="showStraziExternMessage" disabled>
                                <span *ngIf="!straziExternControl.value || straziExternControl.value.length < 2">
                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                </span>
                                <span
                                    *ngIf="isStraziExternLoading && straziExternControl.value && straziExternControl.value.length >= 2">Căutare...</span>
                                <span
                                    *ngIf="!isStraziExternLoading && straziExternLoadComplete && straziExtern.length === 0 && straziExternControl.value && straziExternControl.value.length >= 2">
                                    Nu au fost găsite rezultate
                                </span>
                            </mat-option>

                            <mat-option *ngFor="let strada of straziExtern" [value]="strada">
                                {{ strada.name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="!straziExternControl.valid && straziExternControl.touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                    <button
                        *ngIf="!isStraziExternLoading && straziExternLoadComplete && straziExtern.length === 0 && straziExternControl.value && straziExternControl.value.length >= 2"
                        type="button" class="btn-add-entry" (click)="addStraziExtern()">
                        <i class="icon fa fa-add"></i>
                    </button>
                </div>
                <div class="col-md-4">
                    <mat-form-field appearance="fill">
                        <mat-label>Număr</mat-label>
                        <input type="text" matInput formControlName="numar" />
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Bloc</mat-label>
                        <input type="text" matInput formControlName="bloc" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Scară</mat-label>
                        <input type="text" matInput formControlName="scara" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Apartament</mat-label>
                        <input type="text" matInput formControlName="apartament" />
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="fill">
                        <mat-label>Cod Poștal</mat-label>
                        <input type="text" matInput formControlName="cod_postal" />
                    </mat-form-field>
                </div>
            </div>
        </form>

        <ng-container *ngIf="!onlyView">
            <h3 class="m-0">Documente conexe</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <ng-container *ngIf="!showSelectedDocs">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <button type="button" style="background-color:#f39c12; border-color: #e08e0b; color: #fff"
                            class="btn-general" (click)="changeView()">
                            <i class="fa fa-angle-double-left"></i>
                            <span>Vizualizare documente adăugate/selectate</span>
                        </button>
                    </div>
                    <div class="col-md-6 mb-3 d-flex justify-content-end">
                        <button type="button" style="background-color:#00c0ef; border-color: #00acd6; color: #fff"
                            class="btn-general" (click)="refresh()">
                            <i class="fa fa-refresh"></i>
                            <span> Resetare Căutare</span>
                        </button>
                    </div>
                </div>

                <form [formGroup]="formFilters">
                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Serie</mat-label>
                                <mat-select formControlName="id_serie">
                                    <mat-option *ngFor="let option of serii"
                                        [value]="option.id">{{option.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Destinatar</mat-label>
                                <input type="text" matInput [formControl]="entitatiFiltersControl"
                                    [matAutocomplete]="autoEntitateFilters" (blur)="onEntitateFiltersBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                                <mat-autocomplete #autoEntitateFilters="matAutocomplete"
                                    [displayWith]="displayEntitateFilters"
                                    (optionSelected)="onEntitateFiltersSelected($event.option.value)">
                                    <mat-option *ngIf="showEntitatiFiltersMessage" disabled>
                                        <span
                                            *ngIf="!entitatiFiltersControl.value || entitatiFiltersControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isEntitatiFiltersLoading && entitatiFiltersControl.value && entitatiFiltersControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isEntitatiFiltersLoading && entitatiFiltersLoadComplete && entitatiFilters.length === 0 && entitatiFiltersControl.value && entitatiFiltersControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let entitate of entitatiFilters" [value]="entitate">
                                        {{ entitate.denumire }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="!entitatiFiltersControl.valid && entitatiFiltersControl.touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Număr</mat-label>
                                <input type="number" matInput formControlName="numar_document" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field>
                                <mat-label>Dată inregistrare</mat-label>
                                <input matInput [matDatepicker]="dateInregistrarePicker"
                                    formControlName="data_inregistrare" readonly
                                    (focus)="dateInregistrarePicker.open()" />
                                <mat-hint>ZZ/LL/AAAA</mat-hint>
                                <mat-datepicker-toggle matIconSuffix
                                    [for]="dateInregistrarePicker"></mat-datepicker-toggle>
                                <mat-datepicker #dateInregistrarePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Tip Document</mat-label>
                                <input matInput [formControl]="tipDocumenteControl" [matAutocomplete]="autoTipDocumente"
                                    (blur)="onTipDocumenteBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoTipDocumente="matAutocomplete"
                                    [displayWith]="displayTipDocumente"
                                    (optionSelected)="onTipDocumenteSelected($event.option.value)">
                                    <mat-option *ngIf="showTipDocumenteMessage" disabled>
                                        <span
                                            *ngIf="!tipDocumenteControl.value || tipDocumenteControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isTipDocumenteLoading && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isTipDocumenteLoading && tipDocumenteLoadComplete && tipDocumente.length === 0 && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let doc of tipDocumente" [value]="doc">
                                        {{ doc.name }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="!tipDocumenteControl.valid && tipDocumenteControl.touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>CNP/CIF</mat-label>
                                <input type="string" matInput formControlName="cnp_cui" />
                            </mat-form-field>
                        </div>
                    </div>
                </form>

                <button (click)="searchDocuments()" class="btn-general w-100 my-2"
                    style="background-color: #3c8dbc; border-color: #367fa9; color: #fff;">
                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                    <span>Caută documente</span>
                </button>

                <div class="divider-container">
                    <div class="line"></div>
                    <span class="text">REZULTATE - DOCUMENTE - FILTRE APLICATE</span>
                    <div class="line"></div>
                </div>

                <table class="table table-condensed">
                    <thead>
                        <tr>
                            <th>
                                <span *ngIf="!selectedDocuments.length">#</span>
                                <button *ngIf="selectedDocuments.length" class="btn btn-sm btn-small p-1 my-1"
                                    [ngClass]="selectedDocumentsNr !== selectedDocuments.length ? 'btn-success' : 'btn-danger'"
                                    (click)="selectAllDocuments()">
                                    {{ selectedDocumentsNr !== selectedDocuments.length ? 'Toate' : 'Deselectare'}}
                                </button>
                            </th>
                            <th>Crt.</th>
                            <th>Nr. Reg.</th>
                            <th>Dată Înregistrare</th>
                            <th>Origine Operator</th>
                            <th>Destinatar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="!selectedDocuments.length">
                            <td colspan="6" class="text-center py-2">
                                <strong><i>Lipsă înregistrări</i></strong>
                            </td>
                        </tr>
                        <tr *ngFor="let row of selectedDocuments; let i = index">
                            <td style="min-width: 80px">
                                <button class="btn btn-sm btn-small p-1 my-1"
                                    [ngClass]="row.selected ? 'btn-success' : 'btn-danger'" (click)="selectDocument(i)">
                                    {{ !row.selected ? 'Alege' : 'Selectat' }}
                                </button>
                            </td>
                            <td>{{ i + 1 }}</td>
                            <td>{{ row.reg_number || 'n/a' }}</td>
                            <td>
                                {{ row.created_at ? (row.created_at | date : "dd.MM.yyyy HH:mm" : "ro")
                                : 'n/a' }}
                            </td>
                            <td><i class="fa fa-user"></i> {{ row.origin_user|| 'n/a' }}</td>
                            <td><i class="fa-solid fa-arrow-right"></i><i class="fa fa-user"></i> {{ row.entity.denumire
                                ||
                                'n/a' }}</td>
                        </tr>
                    </tbody>
                </table>

                <button *ngIf="selectedDocuments.length > 0" (click)="addDocumentsToConexe()"
                    class="btn-general w-100 my-2"
                    style="background-color: #00a65a;  border-color: #008d4c; color: #fff;">
                    <span>Adaugă documente în Conexe ({{selectedDocumentsNr}})</span>
                </button>
            </ng-container>
            <ng-container *ngIf="showSelectedDocs">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <button type="button" style="background-color: #3c8dbc; border-color: #367fa9; color: #fff;"
                            class="btn-general" (click)="refreshConexeDocs()">
                            <i class="fa fa-refresh"></i>
                            <span>Resetare</span>
                        </button>
                    </div>
                    <div class="col-md-6 mb-3 d-flex justify-content-end">
                        <button type="button" style="background-color:#f39c12; border-color: #e08e0b; color: #fff"
                            class="btn-general" (click)="changeView()">
                            <span>Adăugare documente conexe</span>
                            <i class="fa fa-angle-double-right"></i>
                        </button>
                    </div>
                </div>

                <div class="divider-container mb-3">
                    <div class="line"></div>
                    <!-- <span class="text"></span> -->
                    <div class="line"></div>
                </div>

                <table class="table table-condensed">
                    <thead>
                        <tr>
                            <th>Acțiune</th>
                            <th>Crt.</th>
                            <th>Nr. Reg.</th>
                            <th>Dată Înregistrare</th>
                            <th>Origine Operator</th>
                            <th>Destinatar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="!conexeDocuments.length">
                            <td colspan="6" class="text-center py-2">
                                <strong><i>Lipsă înregistrări</i></strong>
                            </td>
                        </tr>
                        <ng-container *ngFor="let row of conexeDocuments; let i = index">
                            <tr *ngIf="row.selected">
                                <td style="min-width: 70px">
                                    <button class="btn btn-sm btn-small p-1 my-1 btn-danger"
                                        (click)="deleteConexeDoc(i)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </td>
                                <td>{{ i + 1 }}</td>
                                <td>{{ row.reg_number || 'n/a' }}</td>
                                <td>
                                    {{ row.created_at ? (row.created_at | date : "dd.MM.yyyy HH:mm" : "ro")
                                    : 'n/a' }}
                                </td>
                                <td><i class="fa fa-user"></i> {{ row.origin_user|| 'n/a' }}</td>
                                <td><i class="fa-solid fa-arrow-right"></i><i class="fa fa-user"></i> {{
                                    row.entity.denumire
                                    ||
                                    'n/a' }}</td>
                        </ng-container>
                    </tbody>
                </table>
            </ng-container>
        </ng-container>

        <form [formGroup]="form">
            <h3 class="m-0">Informații</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Greutate trimitere (kg)</mat-label>
                        <input type="number" matInput formControlName="greutate" />
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>ID borderou</mat-label>
                        <input type="number" matInput formControlName="id_borderou" />
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Conținut</mat-label>
                        <textarea matInput formControlName="continut"></textarea>
                        <mat-error *ngIf="!form.controls['continut'].valid && form.controls['continut'].touched">
                            Câmp obligatoriu
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Observații</mat-label>
                        <textarea matInput formControlName="observatii"
                            placeholder="Dacă există observații..."></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Status (AWB)</mat-label>
                        <mat-select formControlName="status_posta">
                            <mat-option *ngFor="let option of statusPostaOptions"
                                [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="fill">
                        <mat-label>Status Expediție INDOC</mat-label>
                        <mat-select formControlName="status">
                            <mat-option *ngFor="let option of statusIndocOptions"
                                [value]="option.id">{{option.name}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div *ngIf="!onlyView" class="row">
                <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
                <div class="col d-flex gap-2 justify-content-between flex-wrap">
                    <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                        {{ helper.dialogConfig.buttonLabels.close }}
                    </button>
                    <div class="d-flex gap-2 flex-wrap">
                        <button class="buttons" type="submit" mat-flat-button color="primary" (click)="submitForm(0)">
                            Salvează pentru mai târziu
                        </button>
                        <button class="buttons" type="submit" mat-flat-button color="success" (click)="submitForm(1)">
                            Generează AWB
                        </button>
                    </div>
                </div>
            </div>
            <div *ngIf="onlyView" class="row">
                <div class="col d-flex gap-2 justify-content-start flex-wrap">
                    <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                        {{ helper.dialogConfig.buttonLabels.close }}
                    </button>
                </div>
            </div>
        </form>
    </ng-container>

    <div class="section-spinner position-fixed" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>